<template>
  <section v-loading="subLoading">
    <qx-search-box
      class="searchBox"
      ref="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
      :customSub="true"
    />
    <TableBox ref="tableBox"/>
    <SubBtnBox
        :customPosifix="false"
        :cancelTextName="'返回'"
        @sub="submit">
    </SubBtnBox>

  </section>
</template>

<script>
import TableBox from './tableBox';
import SubBtnBox from 'components/subBtnBox';
import {saveFenceVehicleBinding} from 'api/operate';
export default {
  components: {
    TableBox,
    SubBtnBox,
  },
  data () {
    return {
      subLoading: false,
      searchBoxData: {
        form: [
          {
            label: '围栏名称',
            value: 'fenceName',
            type: 'show',
            default: this.$route.query.fenceName ? decodeURIComponent(this.$route.query.fenceName) : '',
          },
          {
            label: '车牌号',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号',
          },

          {
            label: '是否在围栏中',
            value: 'isBind',
            type: 'checkbox',
            options: [
              {label: '是', value: 1},
              {label: '否', value: 0},
            ],
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      const id = this.$route.query.fenceId;
      if (id) {
        searchBoxData.fenceId = id;
      }
      if (searchBoxData.isBind) {
        searchBoxData.isBind = searchBoxData.isBind.length < 2 ? searchBoxData.isBind[0] : '';
      }
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
    async submit () {
      let arr = [];
      let selectResult = this.$refs.tableBox.tableData.selectResult;
      if (selectResult.length > 0) {
        selectResult.map((item) => {
          arr.push({
            plateNumber: item.plateNumber,
          });
        });
      }
      this.subLoading = true;
      const res = await saveFenceVehicleBinding({
        bindInfos: JSON.stringify(arr),
        fenceId: this.$route.query.fenceId,
      });
      if (!res.failed) {
        this.$message({
          type: 'success',
          message: '保存成功',
        });
        this.subLoading = false;
        this.close();
      } else {
        this.subLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
